import React from "react";

const CAP = "M45 95 A55 55 0 0 1 155 95 Q150 74 125 70 Q100 79 75 70 Q50 74 45 95 Z";

export const HairBack = ({ style, color }) => {
  if (style === "long")
    return <path d="M45 95 Q38 160 48 200 L152 200 Q162 160 155 95 A55 55 0 0 0 45 95Z" fill={color} />;
  if (style === "afro") return <circle cx="100" cy="88" r="76" fill={color} />;
  if (style === "ponytail")
    return <ellipse cx="162" cy="135" rx="14" ry="42" fill={color} transform="rotate(-12 162 135)" />;
  if (style === "pigtails")
    return (
      <g fill={color}>
        <ellipse cx="40" cy="120" rx="15" ry="34" />
        <ellipse cx="160" cy="120" rx="15" ry="34" />
      </g>
    );
  if (style === "braids")
    return (
      <g fill={color}>
        {[0, 1, 2, 3, 4].map((i) => (
          <g key={i}>
            <circle cx={42 + (i % 2) * 3} cy={104 + i * 20} r="10" />
            <circle cx={158 - (i % 2) * 3} cy={104 + i * 20} r="10" />
          </g>
        ))}
      </g>
    );
  return null;
};

export const HairFront = ({ style, color }) => {
  const dark = "rgba(0,0,0,0.18)";
  switch (style) {
    case "buzz":
      return <path d="M47 90 A55 55 0 0 1 153 90 Q140 62 100 58 Q60 62 47 90Z" fill={color} opacity="0.9" />;
    case "sidepart":
      return (
        <g>
          <path d="M45 95 A55 55 0 0 1 155 95 Q152 68 124 64 Q98 82 66 74 Q50 78 45 95Z" fill={color} />
          <path d="M118 66 Q100 78 78 74" stroke={dark} strokeWidth="3" fill="none" strokeLinecap="round" />
        </g>
      );
    case "fade":
      return (
        <g fill={color}>
          <path d="M47 90 A55 55 0 0 1 153 90 Q140 62 100 58 Q60 62 47 90Z" opacity="0.9" />
          <rect x="52" y="34" width="96" height="36" rx="8" />
        </g>
      );
    case "mohawk":
      return (
        <g fill={color}>
          <path d="M47 90 A55 55 0 0 1 153 90 Q140 62 100 58 Q60 62 47 90Z" opacity="0.6" />
          <path d="M86 70 L90 40 L96 22 L100 8 L104 22 L110 40 L114 70 Q100 62 86 70Z" />
        </g>
      );
    case "curly":
      return (
        <g fill={color}>
          <path d={CAP} />
          {[[52, 74], [66, 56], [86, 44], [108, 42], [130, 52], [148, 70]].map(([x, y]) => (
            <circle key={`curl-${x}-${y}`} cx={x} cy={y} r="15" />
          ))}
        </g>
      );
    case "spiky":
      return (
        <path
          d="M45 95 L50 55 L66 70 L78 38 L92 62 L100 28 L108 62 L122 38 L134 70 L150 55 L155 95 Q130 74 100 78 Q70 74 45 95Z"
          fill={color}
        />
      );
    case "ponytail":
      return (
        <g>
          <path d={CAP} fill={color} />
          <circle cx="156" cy="100" r="7" fill="#F472B6" />
        </g>
      );
    case "pigtails":
      return (
        <g>
          <path d={CAP} fill={color} />
          <circle cx="42" cy="92" r="7" fill="#F472B6" />
          <circle cx="158" cy="92" r="7" fill="#F472B6" />
        </g>
      );
    case "braids":
      return (
        <g>
          <path d={CAP} fill={color} />
          <path d="M60 72 L100 80 L140 72" stroke={dark} strokeWidth="3" fill="none" />
        </g>
      );
    case "bun":
      return (
        <g fill={color}>
          <path d={CAP} />
          <circle cx="100" cy="36" r="19" />
          <circle cx="100" cy="36" r="9" fill={dark} />
        </g>
      );
    case "afro":
      return <path d="M45 95 A55 55 0 0 1 155 95 Q140 70 100 66 Q60 70 45 95Z" fill={color} />;
    default:
      return <path d={CAP} fill={color} />;
  }
};

export const Outfit = ({ style, color, skin }) => {
  const dark = "rgba(0,0,0,0.22)";
  const torso = "M55 162 Q55 150 70 150 L130 150 Q145 150 145 162 L150 240 L50 240 Z";
  const sleeves = (fill, long = true) => (
    <g>
      <rect x="34" y="153" width="24" height={long ? 62 : 38} rx="9" fill={fill} />
      <rect x="142" y="153" width="24" height={long ? 62 : 38} rx="9" fill={fill} />
      {!long && (
        <g fill={skin}>
          <rect x="37" y="182" width="18" height="34" rx="8" />
          <rect x="145" y="182" width="18" height="34" rx="8" />
        </g>
      )}
      <circle cx="46" cy="218" r="9" fill={skin} />
      <circle cx="154" cy="218" r="9" fill={skin} />
    </g>
  );
  if (style === "overalls")
    return (
      <g>
        <path d={torso} fill="#F8FAFC" />
        {sleeves("#F8FAFC", false)}
        <rect x="70" y="168" width="60" height="72" rx="8" fill={color} />
        <rect x="74" y="148" width="10" height="26" rx="4" fill={color} />
        <rect x="116" y="148" width="10" height="26" rx="4" fill={color} />
        <circle cx="79" cy="176" r="4" fill="#FDE68A" />
        <circle cx="121" cy="176" r="4" fill="#FDE68A" />
        <rect x="88" y="200" width="24" height="18" rx="4" fill={dark} />
      </g>
    );
  if (style === "apron")
    return (
      <g>
        <path d={torso} fill={color} />
        {sleeves(color)}
        <path d="M66 178 L134 178 L142 240 L58 240 Z" fill="#FFF7ED" />
        <rect x="84" y="200" width="32" height="22" rx="5" fill="#FDBA74" />
        <path d="M66 178 Q100 150 134 178" stroke="#FFF7ED" strokeWidth="5" fill="none" />
      </g>
    );
  if (style === "dress")
    return (
      <g>
        <path d="M64 150 L136 150 L142 180 L168 240 L32 240 L58 180 Z" fill={color} />
        {sleeves(color, false)}
        <path d="M58 180 L142 180 L144 188 L56 188 Z" fill={dark} />
        <circle cx="100" cy="184" r="5" fill="#FDE68A" />
        <path d="M84 150 Q100 168 116 150" fill="#fff" opacity="0.9" />
        <g fill="rgba(255,255,255,0.35)">
          <circle cx="78" cy="215" r="4" /><circle cx="122" cy="222" r="4" /><circle cx="100" cy="228" r="3" />
        </g>
      </g>
    );
  return (
    <g>
      <path d={torso} fill={color} />
      {sleeves(color, style !== "tee" && style !== "jersey")}
      {style === "hoodie" && (
        <g>
          <path d="M62 170 Q100 118 138 170 Z" fill={dark} />
          <rect x="74" y="200" width="52" height="26" rx="9" fill={dark} />
          <line x1="92" y1="158" x2="90" y2="190" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
          <line x1="108" y1="158" x2="110" y2="190" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
        </g>
      )}
      {style === "jersey" && (
        <g>
          <rect x="55" y="205" width="90" height="10" fill="#fff" opacity="0.9" />
          <text x="100" y="196" textAnchor="middle" fontSize="34" fontWeight="900" fill="#fff" fontFamily="sans-serif">
            7
          </text>
        </g>
      )}
      {style === "tee" && <path d="M84 150 Q100 166 116 150" fill={dark} />}
    </g>
  );
};

export const Accessory = ({ type, color }) => {
  switch (type) {
    case "glasses":
      return (
        <g stroke="#1E293B" strokeWidth="4" fill="rgba(255,255,255,0.18)">
          <circle cx="80" cy="92" r="16" />
          <circle cx="120" cy="92" r="16" />
          <line x1="96" y1="92" x2="104" y2="92" />
        </g>
      );
    case "cap":
      return (
        <g>
          <path d="M42 80 A58 58 0 0 1 158 80 L158 88 L42 88Z" fill={color} />
          <path d="M92 80 L180 78 Q184 90 172 92 L92 92Z" fill={color} />
          <path d="M92 80 L180 78 Q184 90 172 92 L92 92Z" fill="rgba(0,0,0,0.2)" />
          <circle cx="100" cy="30" r="6" fill={color} />
        </g>
      );
    case "headband":
      return <path d="M46 78 A55 55 0 0 1 154 78 L154 92 A55 55 0 0 0 46 92Z" fill={color} />;
    case "bow":
      return (
        <g fill={color}>
          <path d="M140 52 L118 40 L118 64 Z" />
          <path d="M140 52 L162 40 L162 64 Z" />
          <circle cx="140" cy="52" r="7" fill="rgba(0,0,0,0.25)" />
        </g>
      );
    case "bandana":
      return (
        <g fill={color}>
          <path d="M45 90 A55 55 0 0 1 155 90 Q100 100 45 90Z" />
          <path d="M150 88 L172 100 L160 106 Z" />
        </g>
      );
    case "crown":
      return (
        <g>
          <path d="M60 60 L70 30 L85 50 L100 22 L115 50 L130 30 L140 60 Z" fill="#FBBF24" />
          <rect x="60" y="56" width="80" height="10" fill="#F59E0B" />
          <circle cx="100" cy="40" r="4" fill="#EF4444" />
          <circle cx="72" cy="44" r="3" fill="#3B82F6" />
          <circle cx="128" cy="44" r="3" fill="#3B82F6" />
        </g>
      );
    default:
      return null;
  }
};
